import apps from "./apps";
import pages from "./pages";
import main from "./main";
import components from "./components";

const navigation = [...main, ...apps, ...pages, ...components];

export default navigation